<template>
  <vue2Dropzone
    ref="myVueDropzone"
    id="dropzone"
    v-on:vdropzone-sending-multiple="uploading = true"
    v-on:vdropzone-queue-complete="uploading = false"
    v-on:vdropzone-s3-upload-error="s3UploadError"
    v-on:vdropzone-success="fileUploadaded"
    :awss3="awss3"
    v-on:vdropzone-removed-file="fileRemoved"
    v-on:vdropzone-file-added-manually="setOnClickEvent"
    :options="dropzoneOptions"
  ></vue2Dropzone>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'SEUploadInput',
  components: {
    vue2Dropzone
  },
  props: ['value'],
  watch: {
    value: function(val) {
      let self = this
      if (self.newFiles.length == 0 && val.length > 0) {
        val.forEach(function(f) {
          let file = {
            size: f.size,
            name: f.name,
            type: f.name,
            s3ObjectLocation: f.s3ObjectLocation
          }
          let url = f.s3ObjectLocation
          self.$refs.myVueDropzone.manuallyAddFile(file, url)
        })
      }
      this.newFiles = val
    }
  },
  data: function() {
    return {
      newFiles: [],
      awss3: {
        signingURL: f => {
          return (
            'https://phi87a8msl.execute-api.eu-west-1.amazonaws.com/default/Ecobanka-S3PresignedUpload?fileName=' +
            f.name
          )
        },
        headers: {},
        params: {
          fileName: 'asdasdasd'
        },
        sendFileToServer: true,
        withCredentials: false
      },
      dropzoneOptions: {
        url:
          'https://webhook.site/29109250-2f84-4c57-b8d1-02910b565576',
        method: 'put',
        thumbnailWidth: 150,
        maxFilesize: 150,
        acceptedFiles:
          '.csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,zip, image/jpeg,application/x-zip,video/*,.xlsx,application/octet-stream,video/mp4,application/x-zip-compressed,application/vnd.ms-excel,.xls,application/zip,image/png,application/pdf,video/x-m4v',
        addRemoveLinks: true,
        dictDefaultMessage: this.$t(
          'ARRASTRA O HAZ CLICK PARA SUBIR LOS ARCHIVOS'
        ),
        dictRemoveFile: this.$t('Eliminar'),
        dictCancelUpload: this.$t('Cancelar'),
        dictUploadCanceled: this.$t('Cancelado'),
        dictInvalidFileType: this.$t('Tipo de archivo no válido'),
        dictFileTooBig: this.$t('El archivo ocupa demasiado'),
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          'Cache-Control': null,
          'X-Requested-With': null
        }
      }
    }
  },
  computed: {},
  mounted() {
    console.log(this.value)
  },
  methods: {
    s3UploadError: function(error) {
      console.log(error)
    },
    setOnClickEvent: function(file) {
      console.log(file)
      file.previewElement.onclick = function() {
        window.open(file.s3ObjectLocation)
      }
    },
    fileUploadaded: function(file) {
      file.previewElement.onclick = function() {
        window.open(file.s3ObjectLocation)
      }
      this.newFiles.push({
        size: file.size,
        name: file.name,
        type: file.type,
        s3ObjectLocation: file.s3ObjectLocation
      })
      this.$emit('input', this.newFiles)
    },
    fileRemoved: function(file) {
      this.newFiles = this.newFiles.filter(
        e => e.s3ObjectLocation !== file.s3ObjectLocation
      )
      this.$emit('input', this.newFiles)
    }
  }
}
</script>

<style lang="scss">
.centered-content {
  text-align: center !important;
}

.chat-input-container #dropzone {
  border: none;
  border-top: #de4281 solid 2px;
  display: flex;
  padding: 0;
  box-shadow: 0 0 15px -5px inset;

  &.dropzone {
    min-height: 0;
  }
  .dz-message {
    margin: auto;
  }
}

.input {
  border-radius: 0 !important;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: rgba(223, 93, 159, 0.64);
}

.dz-filename span {
  cursor: pointer;
}
</style>
